<template>
  <div>
    <div style="margin-top: 5px">
      <el-button v-if="!isExpanded" no="expandAll" type="primary" @click="isExpanded = !isExpanded">{{ $t('Sop.Unfold') }}</el-button>
      <el-button v-else no="putItAllAway" type="primary" @click="isExpanded = !isExpanded">{{ $t('CargoMsg.Cargo_Close2') }}</el-button>
      <el-button v-if="isEdit" type="primary" @click="commitHandler">{{ $t('SystemMaintenance.Save') }}</el-button>
      <el-button v-if="isEdit" type="danger" @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
      <el-button v-if="!isEdit" type="primary" :disabled="assemblyPlanCostIsEdit || !editable" @click="edit">{{ $t('SystemMaintenance.Edit') }}</el-button>
    </div>
    <el-form v-if="isExpanded" :disabled="!isEdit" class="assembly-plan-dialog-form" style="margin-top: 5px;display: flex;flex-wrap: wrap" :label-width="$selectByLang('100px', '140px')" label-position="left">
      <!--航线产品-->
      <el-form-item :label="$t('CargoMsg.Cargo_AirlineProductCode')" required>
        <cargo-advance-select
          no="airlineProductUuid"
          :clearable="false"
          filterable
          :static-options="airlineProductDownList"
          :method-params="{active:true}"
          tag-value="uuid"
          tag-name="name"
          :filter-tag-names="['name']"
          :static-component="new AutoComplete()"
          callback-method-type="value"
          :default-value="form.airlineProductUuid"
          :callback-params="{key:'airlineProductUuid'}"
          @parentCallBack="airlineProductUuidChange"
        />
      </el-form-item>
      <!--产品服务-->
      <el-form-item :label="$t('SeaExport.ServiceProduct')" required>
        <cargo-advance-select
          no="serviceProduct"
          :clearable="false"
          filterable
          :select-type="TYPE_NAMES.basic_data_AirServiceProduct"
          callback-method-type="value"
          :default-value="form.serviceProduct"
          :callback-params="{key:'serviceProduct'}"
          @parentCallBack="p => form.serviceProduct = p.value"
        />
      </el-form-item>
      <!--航司-->
      <el-form-item :label="$t('SeaExport.AirlineCompany')" required>
        <cargo-advance-select
          no="carrierId"
          filterable
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{airCmp:true, companyLob:'airExport',active:true}"
          :default-value="form.carrierId||''"
          :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
          :fields="['shortName', 'chineseName']"
          placeholder=" "
          @parentCallBack="p => form.carrierId = p.value"
        />
      </el-form-item>
      <!--航班号-->
      <el-form-item :label="$t('AirExport.FlightNumber')" required>
        <el-input v-model="form.flightNumber" />
      </el-form-item>
      <!--航班日期-->
      <el-form-item :label="$t('CargoMsg.Cargo_FlightDate')" required>
        <el-date-picker
          v-model="form.flightDate"
          no="flightDate"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          :clearable="false"
          :picker-options="pickerOptions"
          @change="bringDataHandle"
        />
      </el-form-item>
      <!--始发港-->
      <el-form-item :label="$t('CargoMsg.Cargo_OriginPort')" required>
        <cargo-advance-select
          ref="portOfDeparture"
          no="portOfDeparture"
          filterable
          :select-type="TYPE_NAMES.basic_data_Airport"
          :default-value="form.portOfDeparture"
          tag-name="englishName"
          placeholder=" "
          :clearable="false"
          @parentCallBack="p=>{form.portOfDeparture = p.value}"
        />
      </el-form-item>
      <!--目的港-->
      <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')" required>
        <cargo-advance-select
          ref="destinationPortCode"
          no="destinationPortCode"
          filterable
          :select-type="TYPE_NAMES.basic_data_Airport"
          :default-value="form.destinationPortCode"
          tag-name="code"
          placeholder=" "
          :clearable="false"
          @parentCallBack="p=>{form.destinationPortCode = p.value}"
        />
      </el-form-item>
      <!--交货货站-->
      <el-form-item :label="$t('CargoMsg.Cargo_DeliveryCargoStation')" required>
        <cargo-advance-select
          no="cargoTerminalOperation"
          :select-type="TYPE_NAMES.basic_data_AirportCargoTerminal"
          :method-params="{dataType:0, deletionFlag: false}"
          filterable
          :clearable="false"
          :default-value="form.cargoTerminalOperation"
          @parentCallBack="p=>{form.cargoTerminalOperation = p.value}"
        />
      </el-form-item>
      <!--基重-->
      <el-form-item :label="$t('CargoMsg.Cargo_BaseWeight')">
        <auto-number-input
          v-model="form.basicWeight"
          no="basicWeight"
          :precision="3"
          :min="0"
          :enforce-min="true"
        />
      </el-form-item>
      <!--限重-->
      <el-form-item :label="$t('CargoMsg.Cargo_LimitWeight')">
        <auto-number-input
          v-model="form.limitWeight"
          no="limitWeight"
          :precision="3"
          :min="0"
          :enforce-min="true"
        />
      </el-form-item>
      <!--可售舱位-->
      <el-form-item :label="$t('CargoMsg.Cargo_SellableSpace')">
        <auto-number-input
          v-model="form.availableCabinSpace"
          no="availableCabinSpace"
          :precision="3"
          :min="0"
          :enforce-min="true"
        />
      </el-form-item>
      <!--理论体积-->
      <el-form-item :label="$t('CargoMsg.Cargo_TheoreticalVolume')">
        <auto-number-input
          v-model="form.theoryVolume"
          no="theoryVolume"
          :precision="3"
          :min="0"
          :enforce-min="true"
        />
      </el-form-item>
      <!--可售体积-->
      <el-form-item :label="$t('CargoMsg.Cargo_SellableVolume')">
        <auto-number-input
          v-model="form.sellableVolume"
          no="sellableVolume"
          :precision="3"
          :min="0"
          :enforce-min="true"
        />
      </el-form-item>
      <!--出仓指令-->
      <el-form-item :label="$t('CargoMsg.Cargo_ShipmentOrder')" required>
        <cargo-advance-select
          no="instructionType"
          tag-value="code"
          filterable
          :clearable="false"
          :default-value="form.outboundInstruction"
          :static-options="SystemConstants.OUTBOUND_INSTRUCTIONS"
          @parentCallBack="p=>{form.outboundInstruction=p.value}"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import airlineProductVoyage from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyage'
import airlineProductVoyageCost from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyageCost'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { findAssemblyPlan, mergeAssemblyPlan, saveAssemblyPlan } from '@/api/booking/assemblyPlan'
import { deepClone } from '@/utils'
import AssemblyPlanUtils from '@/utils/AssemblyPlanUtils'
import { AutoComplete } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'

export default {
  name: 'AssemblyPlanInfo',
  components: { cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, cargoInputNumber,
    cargoNumericStepper, airlineProductVoyage, airlineProductVoyageCost, AutoNumberInput },
  props: {
    originForm: { type: Object, default: () => {} },
    airlineProductDownList: { type: Array, default: () => [] },
    editable: { type: Boolean, required: false },
    assemblyPlanCostIsEdit: { type: Boolean, required: false }
  },
  data() {
    return {
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      AutoComplete,
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      delAssemblyPlanCostKeys: [],
      isExpanded: true, // 是否 展开
      isEdit: false, // 是否 编辑
      form: {}
    }
  },
  watch: {
    originForm: {
      immediate: true,
      handler(newVal) {
        this.form = this.originForm
      }
    }
  },
  methods: {
    cancel() {
      this.form = this.originForm
      this.isEdit = false
      this.$emit('isEdit', this.isEdit)
    },
    edit() {
      this.form = deepClone(this.originForm)
      this.form.assemblyPlanUlds = []
      this.isEdit = true
      this.$emit('isEdit', this.isEdit)
    },
    disabledDate(currDate) {
      if (this.form.airlineProductUuid) {
        const airlineProduct = this.airlineProductDownList.find(p => p.uuid === this.form.airlineProductUuid)
        if (airlineProduct) {
          // 禁用不在日期范围内的日期
          if (ColumnUtils.dateLabelFunc(currDate) < ColumnUtils.dateLabelFunc(airlineProduct.beginDate) ||
            ColumnUtils.dateLabelFunc(currDate) > ColumnUtils.dateLabelFunc(airlineProduct.endDate)) {
            return true
          }

          if (!airlineProduct.voyages || airlineProduct.voyages.length === 0) {
            return true
          }
          // 获取星期几
          const dayOfWeek = currDate.getDay() || 7
          const voyage = airlineProduct.voyages.find(p => p.voyage === dayOfWeek)
          if (voyage) {
            return false
          }
        }
      }
      return true
    },
    airlineProductUuidChange(obj) {
      this.form.airlineProductUuid = obj.value
      this.bringDataHandle()
    },
    bringDataHandle() {
      // 清空 原成本
      if (this.form.assemblyPlanCosts && this.form.assemblyPlanCosts.length > 0) {
        for (var assemblyPlanCost of this.form.assemblyPlanCosts) {
          if (assemblyPlanCost.uuid) {
            this.delAssemblyPlanCostKeys.push(assemblyPlanCost.uuid)
          }
        }
        this.form.assemblyPlanCosts = []
      }
      AssemblyPlanUtils.bringDataFromAirlineProduct(this.airlineProductDownList, this.form)
    },
    async commitHandler() {
      if (!this.form.airlineProductUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_AirlineProductCode'))
        return
      }
      if (!this.form.serviceProduct) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.ServiceProduct'))
        return
      }
      if (!this.form.carrierId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.AirlineCompany'))
        return
      }
      if (!this.form.flightNumber) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('AirExport.FlightNumber'))
        return
      }
      if (!this.form.flightDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_FlightDate'))
        return
      }
      if (!this.form.portOfDeparture) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_OriginPort'))
        return
      }
      if (!this.form.destinationPortCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_DestinationPort'))
        return
      }
      if (!this.form.cargoTerminalOperation) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_DeliveryCargoStation'))
        return
      }
      if (this.form.outboundInstruction === 'undefined' || this.form.outboundInstruction === null || this.form.outboundInstruction === '') {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ShipmentOrder'))
        return
      }

      const productVoyage = AssemblyPlanUtils.getProductVoyage(this.airlineProductDownList, this.form)
      // 校验 航班日期 是否在航线产品的有效期内，是否在航线产品-航次对应的日期内
      if (!productVoyage) {
        const flag = await this.$confirm(this.$t('CargoMsg.Cargo_FlightDateError'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }

      this.form.officeCode = this.$store.getters.currentOffice.code
      // 新增时校验
      if (!this.form.uuid) {
        const uldItems = this.form.assemblyPlanUlds[0].assemblyPlanUldItems
        if (uldItems && uldItems.length > 0) {
          const serviceProductSet = new Set()
          const airlineProductUuidSet = new Set()
          const carrierIdSet = new Set()
          const portOfDepartureSet = new Set()
          const destinationPortCodeSet = new Set()
          const cargoTerminalOperationSet = new Set()
          uldItems.forEach(uldItem => {
            // 待拼箱的信息 设置到 拼装信息中
            uldItem.quantityAssembly = uldItem.quantityNotAssembly
            uldItem.weightAssembly = uldItem.weightNotAssembly
            uldItem.cubageAssembly = uldItem.cubageNotAssembly
            uldItem.chargeWeightAssembly = uldItem.chargeWeightNotAssembly
            // 校验 【服务产品、航线产品、航司、始发港、目的港、交货货站】是否统一，给出提示、不强制
            serviceProductSet.add(uldItem.serviceProduct)
            airlineProductUuidSet.add(uldItem.airlineProductUuid)
            carrierIdSet.add(uldItem.carrierId)
            portOfDepartureSet.add(uldItem.portOfDeparture)
            destinationPortCodeSet.add(uldItem.destinationPortCode)
            cargoTerminalOperationSet.add(uldItem.cargoTerminalOperation)
          })
          // 校验 【服务产品、航线产品、航司、始发港、目的港、交货货站】是否统一，给出提示、不强制
          const tips = []
          if (serviceProductSet.size > 1) {
            tips.push(this.$t('CargoMsg.Cargo_ServiceProduct'))
          }
          if (airlineProductUuidSet.size > 1) {
            tips.push(this.$t('CargoMsg.Cargo_AirlineProductCode'))
          }
          if (carrierIdSet.size > 1) {
            tips.push(this.$t('CargoMsg.Cargo_Airline2'))
          }
          if (portOfDepartureSet.size > 1) {
            tips.push(this.$t('CargoMsg.Cargo_OriginPort'))
          }
          if (destinationPortCodeSet.size > 1) {
            tips.push(this.$t('CargoMsg.Cargo_DestinationPort'))
          }
          if (cargoTerminalOperationSet.size > 1) {
            tips.push(this.$t('CargoMsg.Cargo_DeliveryCargoStation'))
          }
          if (tips.length > 0) {
            const flag = await this.$confirm(this.$t('CargoMsg.Cargo_UnifiedError', [tips.join(',')]), this.$t('Message.Prompt'), {
              confirmButtonText: this.$t('Message.Yes'),
              cancelButtonText: this.$t('Message.No'),
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => true).catch(() => false)
            if (!flag) {
              return
            }
          }
        }
      }

      // 校验 计划-集装器数量 是否大于 航线产品-航次-集装器数量，给出提示，不强制
      if (this.form.assemblyPlanUlds && this.form.assemblyPlanUlds.length > 0) {
        // 根据 【航线产品】 带出
        if (productVoyage && productVoyage.voyageBoards && this.form.assemblyPlanUlds.length > productVoyage.voyageBoards.length) {
          const flag = await this.$confirm(this.$t('CargoMsg.Cargo_AssemblyPlanExceedsContainerGroup'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('Message.Yes'),
            cancelButtonText: this.$t('Message.No'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (!flag) {
            return
          }
        }
      }

      // 校验 已存在相同的【航线产品、航班日期】的计划，提示：是否并入已存在的拼装计划？
      const existAssemblyPlan = await findAssemblyPlan({ airlineProductUuid: this.form.airlineProductUuid, flightDate: this.form.flightDate }).then(res => res.data)
      if (existAssemblyPlan && existAssemblyPlan.uuid !== this.form.uuid) { // 排除自己
        await this.$confirm(this.$t('CargoMsg.Cargo_JoinExistingAssemblyPlan'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          // 校验 已存在计划的状态，提示：存在已下达的拼装计划，暂不进行合并，请撤销下达后重试。
          if (existAssemblyPlan.status !== SystemConstants.ASSEMBLY_PLAN_STATUS_SAVED.code) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ExistingPlanIssued'))
          } else {
            // 合并计划
            this.loading = getLoading4Cxt()
            const params = {
              assemblyPlan: this.form,
              assemblyPlanUuid: existAssemblyPlan.uuid
            }
            mergeAssemblyPlan(params).then(res => {
              this.$emit('saveAssemblyPlanSuccess', existAssemblyPlan.uuid)
              this.isEdit = false
              this.$emit('isEdit', this.isEdit)
              this.$message.success(this.$t('Message.SaveSuccessfully'))
            }).finally(() => {
              this.loading.close()
            })
          }
        })
      } else {
        this.loading = getLoading4Cxt()
        this.form.delAssemblyPlanCostKeys = this.delAssemblyPlanCostKeys
        this.form.branchId = this.$store.getters.currentOfficeId
        saveAssemblyPlan(this.form).then(res => {
          this.$emit('saveAssemblyPlanSuccess', res.data)
          this.isEdit = false
          this.$emit('isEdit', this.isEdit)
          this.$message.success(this.$t('Message.SaveSuccessfully'))
        }).finally(() => {
          this.loading.close()
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.assembly-plan-dialog-form .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
.assembly-plan-dialog-form .el-form-item {
  margin-left: 20px;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
  /deep/ .el-date-editor{
    width: 300px;
  }
}
</style>
